import { motion } from 'framer-motion';
import { ReactNode, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from './Loading';

interface PageTransitionProps {
  children: ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();

  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, filter: 'blur(10px)', y: 20 }}
      animate={{ opacity: 1, filter: 'blur(0px)', y: 0 }}
      exit={{ opacity: 0, filter: 'blur(10px)', y: -20 }}
      transition={{ 
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1] // Custom ease-out curve for premium feel
      }}
      className="w-full min-h-screen"
    >
      <Suspense fallback={<Loading />}>
        {children}
      </Suspense>
    </motion.div>
  );
}
